import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MuseumOnboardingComponent } from './museum-onboarding.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    NgxUsefulSwiperModule
  ],
  declarations: [MuseumOnboardingComponent],
  exports: [MuseumOnboardingComponent]
})
export class MuseumOnboardingModule { }
